import { useContext, useEffect } from 'react';
import { MessageGeneratorPanel } from '../MessageGenerator/MessageGeneratorPanel';
import {
  MessageGenerationCreateSessionContext,
  MessageGenerationStateContext,
} from '../MessageGenSession/Context';

type Props = {
  segmentationSessionId: string;
  segmentId: string;
  // segmentName: string;
};

export const SegmentMessageGeneration = (props: Props) => {
  const session = useContext(MessageGenerationStateContext);
  const createMessageGenSession = useContext(MessageGenerationCreateSessionContext);

  const hasExistingSession = !!session;

  useEffect(() => {
    if (!hasExistingSession) {
      console.log('No existing message generation session found, creating a new one...');
      if (!props.segmentationSessionId) {
        console.error('segmentationSessionId is required to create message generation session');
        return;
      }
      console.log(
        'Creating message generation session with segmentationSessionId:',
        props.segmentationSessionId
      );
      createMessageGenSession(props.segmentationSessionId, {
        segmentIds: [props.segmentId],
      });
    }
  }, [hasExistingSession, createMessageGenSession, props.segmentationSessionId, props.segmentId]);

  return <MessageGeneratorPanel mode="messages" />;
};
